import posthog from "posthog-js";

const key = process.env.VUE_APP_POSTHOG_KEY;
const host = process.env.VUE_APP_POSTHOG_HOST;
const isEnabled = !!key;

if (isEnabled) {
    posthog.init(key, {
        api_host: host || "https://us.i.posthog.com",
        defaults: "2026-05-30",
        capture_pageview: "history_change"
    });
    console.log("Posthog is enabled");
}

export const trackEvent = (name, properties) => {
    if (!isEnabled) return;
    posthog.capture(name, properties);
};

export const identifyUser = (distinctId, properties) => {
    if (!isEnabled) return;
    posthog.identify(distinctId, properties);
};

export const resetAnalytics = () => {
    if (!isEnabled) return;
    posthog.reset();
};
